import { createContext } from "react";

export interface FrequencyOption {
  label: string;
  sellingPlanId: string;
}

export interface BenefitOption {
  label: string;
  extraInfo?: string;
  modalHeader?: string;
  linkText?: string;
  linkUrl?: string;
}

export interface RefillPreferenceOption {
  label: string;
  price: number;
  productId: string;
  image: string;
}

export interface SubscriptionFormContextType {
  benefits: BenefitOption[];
  productIds: {
    baseProductId: string;
    refillProductId: string;
    fullApplicatorProductId: string;
  };
  prices: {
    basePrice: number;
    subscriptionPrice: number;
    refillSubscriptionPrice: number;
  };
  labels: {
    oneTimePurchase: string;
    subscription: string;
  };
  frequencies: FrequencyOption[];
  refillPreferenceLabels: {
    refillOnly: string;
    fullApplicator: string;
  };
  refillPreferenceImages: {
    refillOnly: string;
    fullApplicator: string;
  };
}

export const DEFAULT_CONTEXT: SubscriptionFormContextType = {
  benefits: [
    {
      label: "Change or cancel anytime",
    },
    {
      label: "Early access to new flavors",
    },
    {
      label: "Lip bloom loss protection",
      extraInfo:
        "If you lose your lip balm, we'll send you a free replacement once per year. Eligible after 1 renewal cycle. ",
      modalHeader: "Loss protection details",
      linkText: "Just contact us!",
      linkUrl: "/pages/contact",
    },
  ],
  productIds: {
    baseProductId: "51167682887991",
    refillProductId: "51167608832311",
    fullApplicatorProductId: "51167608799543",
  },
  prices: {
    basePrice: 18.0,
    subscriptionPrice: 14.4,
    refillSubscriptionPrice: 12,
  },
  labels: {
    oneTimePurchase: "One time purchase",
    subscription: "Subscribe & Save",
  },
  frequencies: [
    {
      sellingPlanId: "9570812215",
      label: "Every month - 20% off",
    },
    {
      sellingPlanId: "9570844983",
      label: "Every 2 months - 20% off",
    },
    {
      sellingPlanId: "9570877751",
      label: "Every 3 months - 20% off",
    },
  ],
  refillPreferenceLabels: {
    refillOnly: "Refill Only",
    fullApplicator: "Full Applicator",
  },
  refillPreferenceImages: {
    refillOnly: "/cdn/shop/files/lip-bloom-refill.png",
    fullApplicator: "/cdn/shop/files/lip-bloom-full-applicator.png",
  },
};

const SubscriptionFormContext =
  createContext<SubscriptionFormContextType>(DEFAULT_CONTEXT);

export default SubscriptionFormContext;
